import { message } from 'antd';
import Row from '../box/row';
import SizedBox from '../box/sizedBox';
import { ReactComponent as CheckCircle } from '../../../../assets/icons/checkCircle.svg';
import { ReactComponent as CancleCircle } from '../../../../assets/icons/cancleCircle.svg';
import { ReactComponent as Close } from '../../../../assets/icons/close.svg';
import Column from '../box/column';
import { LXbody, LXh5 } from '../../texts/lxText';
import { v4 as uuidV4 } from 'uuid';
interface SnackbarProps {
  iconType: 'success' | 'error';
  title: string;
  content: string;
  snackId: string;
}

const Snackbar: React.FC<SnackbarProps> = (props) => {
  const buildIcon = () => {
    switch (props.iconType) {
      case 'success':
        return (
          <SizedBox width={24} height={24}>
            <CheckCircle></CheckCircle>
          </SizedBox>
        );
      case 'error':
        return (
          <SizedBox width={24} height={24}>
            <CancleCircle></CancleCircle>
          </SizedBox>
        );
    }
  };

  return (
    <Row alignItems="center">
      {buildIcon()}
      <SizedBox width={12}></SizedBox>
      <Column flexGrow={1} alignItems="flex-start">
        <LXh5 color="#FFFFFF">{props.title}</LXh5>
        <SizedBox height={2}></SizedBox>
        <LXbody color="#FFFFFF" width={'100%'} textAlign={'start'}>
          {props.content}
        </LXbody>
      </Column>
      <SizedBox width={12}></SizedBox>
      <SizedBox width={24} height={24}>
        <Close onClick={() => message.destroy(props.snackId)}></Close>
      </SizedBox>
    </Row>
  );
};

const showSnackbar = (
  title: string,
  msg: string,
  iconType: 'success' | 'error'
) => {
  const snackId = uuidV4();
  message.open({
    content: (
      <SizedBox width={360}>
        <Snackbar
          iconType={iconType}
          title={title}
          content={msg}
          snackId={snackId}
        ></Snackbar>
      </SizedBox>
    ),
    duration: 3,
    key: snackId,
  });
};

export const showSuccess = (message: string) => {
  return showSnackbar('Success', message, 'success');
};

export const showError = (message: string) => {
  return showSnackbar('Error', message, 'error');
};
